// extracted by mini-css-extract-plugin
export default {"container":"SearchBar_container__Y-Ra5","inputWrapper":"SearchBar_inputWrapper__kJgwP","icon":"SearchBar_icon__Dtyez","input":"SearchBar_input__ZLghz"};